import { defineMessages } from 'react-intl';

const translations = {
  breadcrumbs: {
    channels: {
      id: 'pages.viewChannel.breadcrumbs.channels',
      defaultMessage: 'Channels',
      description: 'Label of the channels breadcrumb of the view channel page',
    },
  },
  unknownChannel: {
    title: {
      id: 'pages.viewChannel.unknownChannel.title',
      defaultMessage: 'Unknown channel',
      description: 'title of the page when channel is unknown',
    },
    message: {
      id: 'pages.viewChannel.unknownChannel.message',
      defaultMessage: 'This channel does not exist',
      description: 'message when an invalid channel is given',
    },
  },
  settings: {
    pos: {
      id: 'settings.pos',
      defaultMessage: 'POS',
      description: 'title of the pos settings',
    },
    invoicing: {
      id: 'settings.invoicing',
      defaultMessage: 'Invoicing',
      description: 'title of the invoicing settings',
    },
    messaging: {
      id: 'settings.messaging',
      defaultMessage: 'Messaging',
      description: 'title of the messaging settings',
    },
    shipping: {
      id: 'settings.shipping',
      defaultMessage: 'Shipping',
      description: 'title of the shipping settings',
    },
    payment: {
      id: 'settings.payment',
      defaultMessage: 'Payment',
      description: 'title of the payment settings',
    },
    orders: {
      id: 'settings.orders',
      defaultMessage: 'Orders',
      description: 'title of the orders settings',
    },
    wms: {
      id: 'settings.wms',
      defaultMessage: 'WMS',
      description: 'title of the wms settings',
    },
  },
};

export default defineMessages(translations);
